// Shared "signed-in user" display helpers.
//
// Both ChatSidebar (components/sidebar/ChatSidebar.js) and AdminDashboardV2
// render an account avatar for the current user; before this file existed
// each computed its own initials independently and had drifted — chat took
// up to 2 alphanumeric characters, admin took only the first raw character
// (so "mr_smith" showed "M" in the dashboard but "MR" in chat). One
// implementation, so a user's badge reads the same everywhere it appears.
export function getInitials(username) {
  if (!username) return "?";
  const alnum = username.replace(/[^a-zA-Z0-9]/g, "");
  return (alnum.slice(0, 2) || username.slice(0, 2)).toUpperCase();
}
